import { TextField, Stack, Chip, TextFieldProps } from "@mui/material";
import { FC, useRef, useState } from "react";


type PickedProps = Omit<TextFieldProps, 'InputProps'|'inputRef'|'value'|'onChange'|'onKeyDown'>

export const StringArrayTextField: FC<PickedProps&{
  list: string[],
  setList: (ls:string[])=>void,
  stackChips: 'row'|'column',
  acceptValue?: (s:string)=>boolean,
}> = ({ list, setList, stackChips, acceptValue = acceptAll, ...rest }) => {
  const [states, setStates] = useState({
    inputStr: '',
  })
  const inputRef = useRef<HTMLInputElement>()
  return (
    <TextField fullWidth {...rest} inputRef={inputRef}
      InputProps={{
        sx: { flexWrap: 'wrap' },
        startAdornment: (list.length > 0 &&
          <Stack direction={stackChips} flex="100%" spacing={1} flexWrap={stackChips === 'row' ? 'wrap' : 'unset'}
          alignItems="start" 
            sx={{ mt: 1.5, mr: 1.5, 
              '& > div.MuiChip-root': {
                height: 'auto', minHeight: 32, ...(stackChips === 'row' && { mt: 0.5 }),
                '& > span.MuiChip-label': {
                  display: 'block',
                  wordBreak: 'break-all',
                  whiteSpace: 'break-spaces',
                  color: theme => theme.palette.mode === 'light' ? '#ad5324' : '#dc8556',
                },
              },
            }} 
            onClick={(e) => {
              if (e.currentTarget === e.target) {
                inputRef.current?.focus()
              }
            }}
          >
            {list.map((s, i) => (
              <Chip key={s} label={s} onDelete={()=>{
                setList([...list.slice(0, i), ...list.slice(i + 1)])
              }} />
            ))}
          </Stack>
        )
      }}
      // placeholder="add new Root Folder, type Enter key to confirm..."
      value={states.inputStr}
      onChange={(e)=> { setStates(v => ({...v, inputStr: e.target.value}))}}
      onKeyDown={(e)=> {
        if (e.code === 'Enter' || e.code === 'NumpadEnter') {
          setStates(v => {
            const trimmed = v.inputStr.trim()
            if (!trimmed) { return v }
            if (!acceptValue(trimmed)) {
              return trimmed !== v.inputStr ? {...v, inputStr: trimmed} : v
            }
            setTimeout(() => setList([...list, trimmed]))
            return {...v, inputStr: ''}
          })
          e.preventDefault()
        }
      }}
    />
  )
}

export default StringArrayTextField;

const acceptAll = () => true
